<template>
    <div 
        v-show="isDropDownVisible" 
        class="app-select__overlay"
        @click="collapse"
    />
    <div class="app-select">
        <div
            ref="appSelect"
            class="app-select__input"
            tabindex="0"
            @click="toggle"
            @keydown="onSelectKeydown"
        >
            <span class="app-select__input-label">
                {{ currentSelect.title }}
            </span>
            <div class="app-select__input-arrow-icon-wrapper">
                <span class="app-select__input-arrow-icon" />
            </div>
        </div>
        <div
            class="app-select__dropdown-wrapper"
            :class="dropDownClasses"
        >
            <div class="app-select__dropdown">
                <ul class="app-select__dropdown-ul">
                    <AppSelectElement
                        v-for="(element, elementIndex) in array"
                        :key="element.id"
                        tabindex="0"
                        :value="element"
                        :selected="currentSelect"
                        :is-first-index="elementIndex === 0"
                        :is-last-index="elementIndex === array.length - 1"
                        :on-element-select="onElementSelect"
                        :on-close="onElementClose"
                    />
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import AppSelectElement from '@/components/AppSelectElement'

export default {
    name: 'AppSelect',
    components: {
        AppSelectElement        
    },
    props: {
        targetSelect: {
            type: Object,
            required: true
        },
        array: {
            type: Array,
            required: true
        },
        placeHolder: {
            type: String,
            required: false,
            default: ''
        },
        onSelectUpdate: {
            type: Function,
            required: true
        }
    },
    data: () => ({
        currentSelect: {},
        isDropDownVisible: false
    }),
    computed: {
        ...mapState({
            isGlobalControlLocked: state => state.keyControl.isGlobalControlLocked
        }),
        dropDownClasses() {
            return {
                'hidden': !this.isDropDownVisible
            }
        }
    },
    watch: {
        targetSelect(value) {
            this.setTargetValue(value)
        },
        array(arr) {
            this.currentSelect = arr[0]
        }
    },
    mounted() {
        if (Object.keys(this.targetSelect).length) {
            this.setTargetValue(this.targetSelect)
            return
        }

        this.setDefault()
    },
    methods: {
        expand() {
            this.isDropDownVisible = true
        },
        collapse() {
            this.isDropDownVisible = false
        },
        toggle() {
            this.isDropDownVisible = !this.isDropDownVisible
        },
        setDefault() {
            if (this.placeHolder.length) this.setPlaceholder()
            else this.currentSelect = this.array[0]
        },
        setPlaceholder() {
            this.currentSelect = {
                title: this.placeHolder,
                id: -1
            }
        },
        onElementClose() {
            this.collapse()
            this.$refs.appSelect.focus()
        },
        onElementSelect(value) {
            this.currentSelect = value
            this.onSelectUpdate(value)
            this.onElementClose()
        },
        setTargetValue(value) {
            if (!Object.keys(value).length) this.setDefault()
            else this.currentSelect = value
        },
        onSelectKeydown(event) {
            if (this.isGlobalControlLocked) return
            switch (event.code) {
                case 'Space':
                case 'Enter': {
                    this.toggle()
                    break
                }
                case 'Tab': {
                    if (event.shiftKey) this.collapse()
                    break
                }
            }
        }
    }
}
</script>